var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { blockUserSuccess, unblockUserSuccess, } from '../../redux/users/actionCreators';
import { hideDeviationSuccess, unhideDeviationSuccess } from './actions';
var actionHandlers = handleActions((_a = {},
    _a[blockUserSuccess.toString()] = function (state, _a) {
        var _b;
        var userId = _a.payload;
        return (__assign(__assign({}, state), { users: __assign(__assign({}, state.users), (_b = {}, _b[userId] = {
                isBlocked: true,
            }, _b)) }));
    },
    _a[unblockUserSuccess.toString()] = function (state, _a) {
        var _b;
        var userId = _a.payload;
        return (__assign(__assign({}, state), { users: __assign(__assign({}, state.users), (_b = {}, _b[userId] = {
                isBlocked: false,
            }, _b)) }));
    },
    _a[hideDeviationSuccess.toString()] = function (state, _a) {
        var _b;
        var deviationId = _a.payload;
        return (__assign(__assign({}, state), { deviations: __assign(__assign({}, state.deviations), (_b = {}, _b[deviationId] = {
                isBlocked: true,
            }, _b)) }));
    },
    _a[unhideDeviationSuccess.toString()] = function (state, _a) {
        var _b;
        var deviationId = _a.payload;
        return (__assign(__assign({}, state), { deviations: __assign(__assign({}, state.deviations), (_b = {}, _b[deviationId] = {
                isBlocked: false,
            }, _b)) }));
    },
    _a), { users: {}, deviations: {} });
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map